import { render } from "./Assigned.vue?vue&type=template&id=954e7396&scoped=true"
import script from "./Assigned.vue?vue&type=script&lang=js"
export * from "./Assigned.vue?vue&type=script&lang=js"

import "./Assigned.vue?vue&type=style&index=0&id=954e7396&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-954e7396"]])

export default __exports__